const NotificationIcon2 = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
      >
        <path
          d="M11.8372 3.78924C12.0115 3.35841 12.3105 2.98945 12.6959 2.72965C13.0812 2.46985 13.5354 2.33105 14.0002 2.33105C14.4649 2.33105 14.9191 2.46985 15.3045 2.72965C15.6899 2.98945 15.9889 3.35841 16.1632 3.78924C17.8884 4.26371 19.4101 5.29139 20.4947 6.71447C21.5793 8.13754 22.1668 9.87731 22.1668 11.6666V17.1464L24.3042 20.3524C24.4214 20.5281 24.4887 20.7323 24.499 20.9433C24.5092 21.1543 24.462 21.3641 24.3624 21.5503C24.2627 21.7365 24.1144 21.8922 23.9332 22.0008C23.752 22.1093 23.5447 22.1666 23.3335 22.1666H18.0427C17.9022 23.1385 17.4162 24.0273 16.6738 24.6702C15.9314 25.313 14.9822 25.6668 14.0002 25.6668C13.0181 25.6668 12.0689 25.313 11.3265 24.6702C10.5841 24.0273 10.0981 23.1385 9.95767 22.1666H4.66684C4.45562 22.1666 4.24836 22.1093 4.06716 22.0008C3.88597 21.8922 3.73763 21.7365 3.63799 21.5503C3.53834 21.3641 3.49113 21.1543 3.50137 20.9433C3.51162 20.7323 3.57895 20.5281 3.69617 20.3524L5.83351 17.1464V11.6666C5.83351 7.90524 8.37684 4.73658 11.8372 3.78924ZM12.3505 22.1666C12.471 22.508 12.6944 22.8036 12.99 23.0128C13.2855 23.2219 13.6387 23.3342 14.0008 23.3342C14.3628 23.3342 14.716 23.2219 15.0115 23.0128C15.3071 22.8036 15.5305 22.508 15.651 22.1666H12.3493H12.3505ZM14.0002 5.83325C12.4531 5.83325 10.9693 6.44783 9.87538 7.54179C8.78142 8.63575 8.16684 10.1195 8.16684 11.6666V17.4999C8.16689 17.7304 8.09869 17.9557 7.97084 18.1474L6.84734 19.8332H21.1518L20.0283 18.1474C19.9009 17.9555 19.8331 17.7302 19.8335 17.4999V11.6666C19.8335 10.1195 19.2189 8.63575 18.125 7.54179C17.031 6.44783 15.5473 5.83325 14.0002 5.83325Z"
          fill="#183883"
        />
        <circle
          cx="19.8334"
          cy="6.99967"
          r="4.04167"
          fill="#E62D38"
          stroke="#E9EEFE"
          strokeWidth="1.25"
        />
      </svg>
  );
};
export default NotificationIcon2;
